<template>
  <v-container>
    <v-container v-if="progress" class="justify-center flex-column">
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <br />
      <v-progress-linear indeterminate color="orange"></v-progress-linear>
      <br />
    </v-container>
    <v-snackbar
      v-if="wrongTime"
      :timeout="-1"
      :value="true"
      absolute
      bottom
      color="red"
      outlined
      centered
    >
      Überprüfen Sie bitte den Zeitraum wieder
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="wrongTime = null">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-data-table
      fixed-header
      :height="height - 100"
      :headers="headers"
      :items="userdata"
      item-key="user_id"
      :loading="myloadingvariable"
      loading-text="Loading... Bitte warten"
      @current-items="datenSum"
      loader-height="0"
    >
      <template v-slot:top>
        <!-- v-container, v-col and v-row are just for decoration purposes. -->
        <v-row justify="center">
          <v-col cols="2">
            <v-row class="pa-3">
              <v-text-field
                v-model="nameFilterValue"
                type="text"
                label="Name"
                append-icon="mdi-magnify"
              ></v-text-field>
            </v-row>
          </v-col>
          <v-col cols="2">
            <v-row class="pa-3">
              <v-select
                :items="department"
                v-model="departmentFilterValue"
                label="Abteilung"
              ></v-select>
            </v-row>
          </v-col>
          <v-col cols="2">
            <v-row class="pa-3">
              <v-select
                :items="skills"
                v-model="skillFilterValue"
                label="Skills"
              ></v-select>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row justify="start">
              <v-col cols="3">
                <v-menu
                  ref="menu0"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="from"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="from"
                      label="Von welchem Month"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from"
                    type="month"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="deep-orange" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="deep-orange"
                      @click="$refs.menu0.save(from)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-menu
                  ref="menu"
                  v-model="m"
                  :close-on-content-click="false"
                  :return-value.sync="to"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="to"
                      label="zu welchem Month"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="to" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="deep-orange" @click="m = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="deep-orange"
                      @click="$refs.menu.save(to)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-row class="pa-3">
                  <v-select
                    :items="dataTypeItem"
                    v-model="dataTypeTemp"
                    label="DatenType"
                  ></v-select>
                </v-row>
              </v-col>
              <v-col cols="3" align-self="center">
                <v-btn
                  elevation="3"
                  color="deep-orange"
                  outlined
                  @click="getDataTable()"
                >
                  Bestätigen
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="600px">
          <diagramm-item :data="diagrammItem"></diagramm-item
        ></v-dialog>
      </template>
      <template v-slot:item="{ item }">
        <tr class="orange lighten-4">
          <td class="deep-orange--text">{{ item.name }}</td>
          <td>{{ item.department }}</td>
          <td>
            <v-chip color="deep-orange" dark>
              {{ item.skill }}
            </v-chip>
          </td>
          <td class="blue-grey lighten-4">
            {{ dataType == "forecast" ? "Forecast" : "Soll-Daten" }}
          </td>
          <td
            class="blue-grey lighten-4"
            v-for="(month, index) in item.forecast_daten"
          >
            {{ month }}
          </td>
          <td class="blue-grey lighten-3">
            {{
              item.forecast_daten.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <!-- <v-icon small color="orange" class="mr-2" @click="diagramm(item)">
              mdi-chart-line
            </v-icon> -->
          </td>
          <td class="green--text"></td>
          <td>ist_daten</td>

          <td v-for="(month, index) in item.ist_daten">
            {{ month }}
          </td>
          <td>
            {{
              item.ist_daten.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
      </template>
      <template slot="body.append">
        <tr class="white--text blue-grey darken-3">
          <td></td>
          <td>das Ergebnis des Forecasts</td>

          <td></td>
          <td></td>
          <td v-for="month in this.forecast_datenSum">{{ month }}</td>
          <td class="blue-grey darken-1">
            {{
              this.forecast_datenSum.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr class="white--text blue-grey darken-3">
          <td></td>
          <td>historische Arbeitsstunden pro Tag</td>

          <td></td>

          <td></td>

          <td v-for="month in this.ist_datenSum">{{ month }}</td>
          <td class="blue-grey darken-1">
            {{
              this.ist_datenSum.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
          </td>
        </tr>
        <tr class="white--text orange darken-4">
          <td></td>
          <td>die Abweichung :</td>

          <td></td>

          <td></td>

          <td v-for="month in precent_data">{{ Math.round(month) }}</td>
          <td class="orange lighten-1">
            {{
              Math.round(
                forecast_datenSum.reduce(function (pv, cv) {
                  return pv + cv;
                }, 0) -
                  ist_datenSum.reduce(function (pv, cv) {
                    return pv + cv;
                  }, 0)
              )
            }}
            %
          </td>
        </tr>
        <!-- <tr>
          <td></td>
          <td>Anzahl. Arbeitstage S.A</td>

          <td></td>

          <td></td>

          <td v-for="month in workDays">{{ month }}Tage</td>
          <td class="">
            {{
              workDays.reduce(function (pv, cv) {
                return pv + cv;
              }, 0)
            }}
            Tage
          </td>
        </tr> -->
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from "axios";
import DiagrammItem from "../DiagrammItem";
export default {
  components: { DiagrammItem },

  data() {
    return {
      progress: true,
      from: new Date(new Date().getFullYear(), 0, 2).toISOString().substr(0, 7),
      to: new Date().toISOString().substr(0, 7),
      menu: false,
      modal1: false,
      modal2: false,
      height: this.$vuetify.breakpoint.height,
      loadingo: true,
      year: new Date().getFullYear(),
      thisMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      monthes: null,
      dialog: false,
      wrongTime: false,
      diagrammItem: undefined,
      skills: [],
      department: [],
      workDays: [],
      search: "",
      ist_datenSum: [],
      forecast_datenSum: [],
      precent_data: [],
      nameFilterValue: "",
      skillFilterValue: null,
      departmentFilterValue: null,
      myloadingvariable: true,
      userdata: undefined,
      headers: ForecastHelper.peakHeaders(this),
      dataType: "forecast",
      dataTypeTemp: "forecast",
      dataTypeItem: ["forecast", "soll_daten"],
    };
  },
  methods: {
    getDataTable() {
      this.dataType = this.dataTypeTemp;
      this.userdata = undefined;
      this.wrongTime = false;

      if (this.from > this.to) {
        this.wrongTime = true;
      }
      if (this.from <= this.to) {
        axios
          .get(`/forecast/historyCompiling`, {
            params: { from: this.from, to: this.to, dataType: this.dataType },
          })
          .then((res) => {
            let header1 = ForecastHelper.setHeader(res.data.tableHeaders);
            this.headers = ForecastHelper.peakHeaders(this);
            let header2 = this.headers;
            this.headers = header2.concat(header1);
            this.userdata = res.data.data;
            this.progress = false;
          });
        //.catch((error) => console.log(error.response.data));
      }
    },
    datenSum(e) {
      let i;
      var is_datenSum0 = [];
      var forecast_datenSum0 = [];

      for (i = 0; i < Object.keys(e).length; i++) {
        is_datenSum0[i] = e[i].ist_daten;
        forecast_datenSum0[i] = e[i].forecast_daten;
      }

      if (this.userdata) {
        this.ist_datenSum = is_datenSum0[0].map((x, idx) =>
          is_datenSum0.reduce((sum, curr) => sum + curr[idx], 0)
        );
        this.forecast_datenSum = forecast_datenSum0[0].map((x, idx) =>
          forecast_datenSum0.reduce((sum, curr) => sum + curr[idx], 0)
        );

        this.precent_data = [];
        for (i = 0; i < this.headers.length - 4; i++) {
          this.precent_data[i] =
            this.forecast_datenSum[i] - this.ist_datenSum[i];
        }
      }
      if (this.userdata) {
        // this.workDays = this.userdata[1].workDays;
        // console.log(this.workDays);
      }
    },
    sumField(key) {
      // sum data in give key (property)
      return this.userdata.reduce((a, b) => a + (b[key] || 0), 0);
    },
    nameFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.nameFilterValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.nameFilterValue.toLowerCase());
    },
    skillFilter(value) {
      if (!this.skillFilterValue) {
        return true;
      }
      return value.toLowerCase().includes(this.skillFilterValue.toLowerCase());
    },
    departmentFilter(value) {
      if (!this.departmentFilterValue) {
        return true;
      }

      return value
        .toLowerCase()
        .includes(this.departmentFilterValue.toLowerCase());
    },

    loading() {
      if (userdata) {
        this.myloadingvariable = true;
      }
    },
    diagramm(item) {
      this.diagrammItem = item;
      this.dialog = true;
    },
  },
  created() {
    this.getDataTable();
    axios
      .get(`/forecast/department`)
      .then((res) => {
        this.department = res.data.departments;
        this.department.push("");
        this.skills = res.data.skills;
      })
      .catch((error) => console.log(error.response.data));
  },
};
</script>